class ScrollspyNavigation extends window.HTMLElement {
  constructor() {
    super();
    this.sections = [];
    this.links = [];
    this.observer = null;
    this.currentActiveLink = null;
  }
  connectedCallback() {
    this.sections = this.querySelectorAll("[data-scrollspy-section]");
    this.links = this.querySelectorAll("[data-scrollspy-link]");
    if (this.sections.length === 0 || this.links.length === 0) {
      return;
    }
    this.setupLinkListeners();
    this.setupIntersectionObserver();
    this.setInitialActiveState();
  }
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  setupLinkListeners() {
    this.links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = link.getAttribute("data-target");
        const targetSection = document.getElementById(targetId);
        if (targetSection) {
          const offsetTop = targetSection.offsetTop - 100;
          window.scrollTo({
            top: offsetTop,
            behavior: "smooth"
          });
          this.setActiveLink(link);
        }
      });
    });
  }
  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: "-20% 0px -60% 0px",
      // Trigger when section is in middle of viewport
      threshold: 0
    };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          const correspondingLink = this.findLinkByTarget(sectionId);
          if (correspondingLink) {
            this.setActiveLink(correspondingLink);
          }
        }
      });
    }, options);
    this.sections.forEach((section) => {
      this.observer.observe(section);
    });
  }
  setInitialActiveState() {
    const hash = window.location.hash;
    if (hash) {
      const targetId = hash.substring(1);
      const correspondingLink = this.findLinkByTarget(targetId);
      if (correspondingLink) {
        this.setActiveLink(correspondingLink);
        return;
      }
    }
    if (this.links.length > 0) {
      this.setActiveLink(this.links[0]);
    }
  }
  findLinkByTarget(targetId) {
    return Array.from(this.links).find(
      (link) => link.getAttribute("data-target") === targetId
    );
  }
  setActiveLink(activeLink) {
    if (this.currentActiveLink === activeLink) {
      return;
    }
    this.links.forEach((link) => {
      link.classList.remove("active");
    });
    activeLink.classList.add("active");
    this.currentActiveLink = activeLink;
  }
}
window.customElements.define("scrollspy-navigation", ScrollspyNavigation);
export {
  ScrollspyNavigation as default
};
